<template>
	<div>
		<van-field :required="formCreateInject.rule.validate.required" readonly
			:label="formCreateInject.prop.title.title" :value="valuetext" placeholder="" @click="show"
			input-align="right">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>
		<van-popup v-model="showPicker" round position="bottom" :safe-area-inset-bottom="true" get-container="body">
			<template v-if="!optionsFromRow">
				<van-picker :title="formCreateInject.prop.title.title" value-key="label" show-toolbar :columns="options"
					@cancel="showPicker = false" @confirm="onConfirm" />
			</template>
			<template v-else>
				<van-picker :title="formCreateInject.prop.title.title" value-key="label" show-toolbar :columns="options"
					@cancel="showPicker = false" @confirm="onConfirm" />
			</template>

		</van-popup>
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			optionsFromRow: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				ready: false,
				showPicker: false,
				options: [],
				columns: [],
				valuetext: ''
			}
		},
		created() {
			this.list()

		},
		mounted() {

			// if (this.$slots.append) {
			// 	this.$refs.input.setAttribute('readonly', true)
			// }
			//console.log(this.$refs.input)
			// 	let i = document.createElement('i')
			// 	this.$refs.input.parentNode.appendChild(<i class="el-icon-delete"></i>)



		},
		watch: {
			value(value) {
				this.getValuetext(value)
			},
			// disabled(val) {
			// 	if (this.$slots.append && val) {
			// 		this.hiddenAppend()
			// 	}
			// },
			readonly() {
				//console.log(this)
			}
		},
		computed: {

		},
		methods: {
			list(){
				if (this.optionsFromRow) {
					this.options = []
					let row = this.table.getTableData().fullData.find((item) => {
						if(this.formCreateInject.api.rowSourceData){
							return item._X_ROW_KEY == this.formCreateInject.api.rowSourceData._X_ROW_KEY
						}else{
							return null
						}
						
					})
					if (row && row.selectoption) {
						this.options = row.selectoption
					}
				}else{
					if(this.selectoptions){
						this.options = this.selectoptions
					}else if(this.formCreateInject){
						this.options = this.formCreateInject.options
					}
					this.getValuetext(this.value)
				}
			},
			show() {
				if (!this.disabled && !this.readonly) {
					this.getOption()
					this.showPicker = true
				}
			},
			onConfirm(value, index) {
				if (value) {
					let postvalue = ''
					if (Array.isArray(value)) {
						let currentobj = this.options
						let objarr = []
						index.forEach((item) => {
							objarr.push(currentobj[item])
							currentobj = currentobj[item].children
						})
						postvalue = objarr.map((item) => {
							return item.id ? item.id : item
						})
					} else {
						postvalue = value.id ? value.id : value
					}
					this.change(postvalue)
				}
				this.showPicker = false
			},
			getValuetext(value) {
				this.valuetext = null
				this.options = this.getOption()
				if(this.options){
					this.options.forEach((item) => {
						if (item.value === value) {
							this.valuetext = item.label
						}
					})
				}else{
					this.valuetext = value
				}
			},
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
			},

		}
	}
</script>
<style scope>




</style>
